var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"flex":"1 0","display":"flex","flex-flow":"column"}},[_c('div',{staticStyle:{"display":"flex","flex":"0 0 auto","flex-flow":"row wrap"}},[_c('button',{on:{"click":function($event){return _vm.startPlaying()}}},[_vm._v("Play")])]),_c('div',{staticStyle:{"display":"flex","flex":"1 0"},attrs:{"id":"container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }